function scrollBanner(direction) {
    const banner = document.querySelector('.carousel-content');
    if (!banner) {
        console.error("Element .carousel-content nebol nájdený!");
        return;
    }

    const item = banner.querySelector('.carousel-item'); // Berieme prvý produkt v rámci banneru
    if (!item) {
        console.error("Element .carousel-item nebol nájdený!");
        return;
    }

    const itemWidth = item.offsetWidth + 20; // Pridáme medzeru medzi položkami
    banner.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });

    console.log(`Posunutie o ${direction * itemWidth}px`); // Debugging
}